import React, { Component } from 'react';
import PieChart from 'react-simple-pie-chart';
import { arrowNDlogSVG } from '../../../Images/GenericSVG.js';
import { connect } from 'react-redux';
import { ConvertHourToInt } from '../../../js/helpers/Utils/ConvertHourToInt';
import { Singleton } from '../../../js/Singleton';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { setNoAvailableRecord, getNoAvailableRecord, observerRecordNAhistory } from '../../../js/Singletons/NoAvailableRecordSingleton'
import { consultingApp, noConsultingApp } from '../../../redux/actions/A_reducer_consulting';
import AlertModalActions from '../../../redux/actions/A_Alert_Modal';
import { alertQueryErrorBody } from '../../../js/alertQueryErrorBody';
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller'
import { DRAGGABLE_WINDOWS } from '../../../constants'

class NoAvailableRecordComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noAvailableList: [],
      itemExpanded: -1
    };
    this.convertHourToInt = new ConvertHourToInt();
    this.language = new Singleton();
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.sharedData = new SingletonSharedData();
  }
  UNSAFE_componentWillMount() {
    if (!this.props.floating) {
      
      this.props.consultingApp();
      let userId = this.sharedData.getParameters().UserID;
      let objectResponse = this.apiCont.getObjectResponse();
      this.apiCont.getNotReadyHistory(userId, objectResponse, this.sharedData.requestTimeout);
     
      let _this = this;
      objectResponse.onError = function (messageError) {
        _this.props.noConsultingApp();
      };
      objectResponse.onSuccess = function (objResponse) {
        _this.props.noConsultingApp();
        setNoAvailableRecord(objResponse.Response);
        _this.setState({ noAvailableList: getNoAvailableRecord() });
        _this.props.noConsultingApp();
      };
      objectResponse.onCatch = function (messageError) {
        _this.props.removeWindow(DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD);
        _this.props.noConsultingApp();
        _this.props.showAlertModal(alertQueryErrorBody()); 
      };
    } else {
      observerRecordNAhistory(() => this.setState({ noAvailableList: getNoAvailableRecord() }));
    }
  }
  renderGrafica(noAvailable) {
    var tiempoMax = (noAvailable.Max).split(":");
    var tiempo = (noAvailable.Time).split(":");
    var porcentajeTiempoMax = this.convertHourToInt.Parse(tiempoMax);
    var porcentajeTiempo = this.convertHourToInt.Parse(tiempo);
    let porcentajeEventos = (noAvailable.Count / noAvailable.Total) * 100;

    var porcentaje = (parseInt(porcentajeTiempo, 10) * 100) / parseInt(porcentajeTiempoMax, 10);
    porcentaje = porcentaje.toFixed(1);

    if (noAvailable.Total > 0) {
      porcentaje = parseInt(porcentaje > porcentajeEventos ? porcentaje : porcentajeEventos, 10);
    }

    let porcentajeGrafica = parseInt(porcentaje, 10);
    if (porcentajeGrafica > 100) {
      porcentajeGrafica = 100;
    }

    if (porcentajeTiempoMax > 0) {
      return <div className="expandedGralInfoTimesNA">
        <div className="graphContainer">
          <PieChart slices={[{ color: '#FF0000', value: porcentajeGrafica }, { color: '#00B0FF', value: 100 - porcentajeGrafica }]} />
          <div className={`circlePie ${(porcentaje > 100 ? "red" : "")} ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{porcentaje + "%"}</div>
        </div>
        <div className="expandedBarTimes">
          <p className={`recordExpandedTxtItemNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.language.getText('GUIDisableHistorytimeUsed') + ":"}</p>
          <p className="recordExpandedTxtItemTimeNA">{noAvailable.Time}</p>
          <p className={`recordExpandedTxtItemNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.language.getText('GUIDisableHistorytimeLimit') + ":"}</p>
          <p className={`recordExpandedTxtItemMaxNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{noAvailable.Max}</p>
        </div>
      </div>
    }
    else {
      return <div className="expandedGralInfoTimesNA timer">
        <div className="onlyTimesExpanded">
          <p className={`recordExpandedTxtItemNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.language.getText('GUIDisableHistorytimeUsed') + ":"}</p>
          <p className="recordExpandedTxtItemTimeNA">{noAvailable.Time}</p>
        </div>
      </div>
    }
  }
  render() {
    return (
      <div className={`NoAvailableRecordContainer ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}` }>
        {(!this.state.noAvailableList.length ?
          <div className="NoAvailableRecordRestricted">
            <p className="NoAvailableRestrictedMessage">{this.language.getText("alert-1510")}</p>
          </div> :
          <div className="containerWorkBar">
            {this.state.noAvailableList.map((item) =>
              <div className="expandedItemNA" key={item.TypeNotReadyId}>
                <div className="expandedGralInfoNA">
                  <div className="expandedIconCountNA">
                    <div className="iconItemNA">{this.sharedData.getIconNoAvailable(item.Frame)}</div>
                    <p className={`expandedQuantityNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{item.Count}/{item.Total}</p>
                  </div>
                  <p className={`expandedRecordTitleNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{item.Description}</p>
                  {this.renderGrafica(item)}
                  <div className={"arrowExpandNA"} onClick={() => this.setState({ itemExpanded: (item.TypeNotReadyId === this.state.itemExpanded ? -1 : item.TypeNotReadyId) })}>{arrowNDlogSVG}</div>
                </div>
                <div className={"expandedTableNA " + (this.state.itemExpanded === -1 ? "" : (this.state.itemExpanded === item.TypeNotReadyId ? "expandedTableShow" : (this.state.itemExpanded === item.TypeNotReadyId ? "expandedTableHidden" : "")))}>
                  <table className="timesTableExpandedBar">
                    <tbody>
                      <tr>
                        <td className={`headersTableNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.language.getText("GUIDisableHistoryevent") + ":"}</td>
                        <td className={`headersTableNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.language.getText("GUIDisableHistoryselectedAt") + ":"}</td>
                        <td className={`headersTableNA ${this.props.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.language.getText("GUIDisableHistoryduration") + ":"}</td>
                      </tr>
                      {item.Detail.map((item, i) =>
                        <tr key={"item" + i}>
                          <td>{('0' + (i + 1)).slice(-2)}</td>
                          <td>{item.Hour}</td>
                          <td>{item.Time}</td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>)}
          </div>)}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { 
    simultaneosRecs: state.preview.simultaneosRecs
  }
}
function mapDispatchToProps(dispatch) {
  const { showAlertModal } = AlertModalActions.creators;  
  return ({
    consultingApp: () => { dispatch(consultingApp()); },
    noConsultingApp: () => { dispatch(noConsultingApp()); },
    showAlertModal: payload => {dispatch(showAlertModal(payload));},
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
  });
}
export default NoAvailableRecordComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(NoAvailableRecordComponent);



// WEBPACK FOOTER //
// ./src/components/workSpace/FloatingSideComponents/NoAvailableRecordComponent.jsx